import React, { Component } from 'react';
import ReactGA from 'react-ga';

export default class ProductList extends Component {
  constructor(props) {
    super(props);
    this.handleRabbitClick = this.handleRabbitClick.bind(this);
  }

  render() {
    let {T} = this.props
    return (
      <div className="products">
          <div className="amp-product">
              <T.text tag="h2" text={"products.title-left"}/>
              <T.text tag="p" text={"products.description-left"}/>
              <a href={T.translate('products.link-href-left')} target="_blank" rel="noopener noreferrer">
                <T.text text={"products.link-text-left"}/>
              </a>
          </div>
          <div className="rabbit-product">
              <T.text tag="h2" text={"products.title-right"}/>
              <T.text tag="p" text={"products.description-right"}/>
              <a href={T.translate('products.link-href-right')} target="_blank" rel="noopener noreferrer" onClick={this.handleRabbitClick}>
                <T.text text={"products.link-text-right"}/>
              </a>
          </div>
      </div>
    );
  }

  handleRabbitClick(e) {
    ReactGA.event({
      category: 'rabbit_generator',
      action: 'click',
      label: 'gomobile-rabbit',
      nonInteraction: true
    });
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/components/layout/product-list.js